import PropTypes from 'prop-types';

const StringOrNumberType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
]);

export const InventoryTagType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string
});

export const InventoryLocationZoneType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string
});

export const InventoryLocationType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  zones: PropTypes.arrayOf(InventoryLocationZoneType),
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string
});

export const InventoryItemType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  photo: PropTypes.string,
  price: StringOrNumberType.isRequired,
  maxCount: PropTypes.number.isRequired,
  minCount: PropTypes.number.isRequired,
  weight: StringOrNumberType.isRequired,
  points: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(InventoryTagType)
});

export const InventoryPackageType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  photo: PropTypes.string,
  price: StringOrNumberType.isRequired,
  maxCount: PropTypes.number.isRequired,
  minCount: PropTypes.number.isRequired,
  weight: StringOrNumberType.isRequired,
  points: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(InventoryTagType),
  items: PropTypes.arrayOf(InventoryItemType),
  availability: PropTypes.arrayOf(PropTypes.shape({}))
});

export const IventoryPackageItemType = PropTypes.shape({
  id: StringOrNumberType.isRequired,
  quantity: PropTypes.number.isRequired,
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  location: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  zone: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string
});

export const InventoryItemSkuType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  sku: PropTypes.string.isRequired,
  itemId: PropTypes.number.isRequired,
  itemType: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string
});

export const InventoryAvailabilityType = PropTypes.shape({
  quantity: PropTypes.number.isRequired,
  price: PropTypes.string.isRequired,
  points: PropTypes.number.isRequired,
  weight: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  onholdQuantity: PropTypes.number,
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    photo: PropTypes.string
  }),
  location: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  zone: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })
});
